var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isClient)?_c('CycleCookieConsent',{attrs:{"heading":_vm.heading,"button-approve-text":_vm.approveText,"link-decline-text":_vm.declineText}},[_c('template',{slot:"jss-content"},[_c('ScRichText',{attrs:{"field":_vm.fields.bodytext}})],1)],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }